import { Col, Row } from "antd";
import { useOrganization } from "../../OrganizationProvider";

const UnauthLayout = (props) => {
  const organization = useOrganization();
  return (
    <Row className="bg">
      <Col xs={0} sm={0} md={0} lg={12} xl={12}>
        <div
          className="banner"
          style={{
            backgroundImage: `url(${organization.s3BucketBaseUrl}/Login.png)`,
          }}
        ></div>
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12} className="flex-center">
        <div className="shadow-card w75">{props.children}</div>
      </Col>
    </Row>
  );
};

export default UnauthLayout;
